module.exports = __webpack_public_path__ + "static/media/MapPin.0fe7f202.svg";